import { render, staticRenderFns } from "./UploadAttachments.vue?vue&type=template&id=c051b7fe&scoped=true"
import script from "./UploadAttachments.vue?vue&type=script&lang=js"
export * from "./UploadAttachments.vue?vue&type=script&lang=js"
import style0 from "./UploadAttachments.vue?vue&type=style&index=0&id=c051b7fe&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c051b7fe",
  null
  
)

export default component.exports